<template>
    <div class="flex flex-col w-full">
        <label v-if="label" :for="inputId" class="font-bold mb-1">{{ label }}</label>
        <div class="relative">
            <select
                :id="inputId"
                v-model="selectedValue"
                :name="name"
                :class="{
                    'text-gray-500': selectedValue === null,
                    'text-gray-700': selectedValue !== null,
                    'border-red-500': error
                }"
                class="block appearance-none w-full bg-gray-200 border border-gray-200 py-3 px-4 pr-8 rounded leading-normal focus:outline-none focus:bg-white focus:border-gray-500"
                @change="onChange"
            >
                <option :value="null" disabled selected>{{ placeholder }}</option>
                <option v-for="(label, value) in options" :key="value" :value="value">{{
                    labelBy ? label[labelBy] : label
                }}</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
            </div>
        </div>

        <span v-if="error" class="mt-1 text-xs text-italic mt-1 text-red-500">
            {{ error }}
        </span>
    </div>
</template>

<script>
import FormInputsMixin from './form_inputs_mixin';

export default {
    mixins: [FormInputsMixin],

    props: {
        labelBy: {
            type: String,
            default: null
        },
        options: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            selectedValue: this.value
        };
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                this.selectedValue = this.value;
            }
        }
    },

    methods: {
        onChange() {
            this.$emit('input', this.selectedValue);
        }
    }
};
</script>
